<style>
/* Navbar fade transitions for AR fullscreen */
.navbar-fade-enter-active,
.navbar-fade-leave-active {
	transition: all 0.3s ease;
}

.navbar-fade-enter-from,
.navbar-fade-leave-to {
	opacity: 0;
	transform: translateY(-20px);
}
</style>

<template>
  <transition name="navbar-fade" mode="out-in">
    <navbar v-if="!isArFullscreenActive"/>
  </transition>
  <!-- Removed nested fade transition - page transitions handled by Child.vue -->
  <slot/>
</template>

<script>
import Navbar from '~/components/Navbar'
import { mapGetters } from 'vuex'

export default {
  name: 'MainLayout',

  components: {
    Navbar
  },

   computed: {
    ...mapGetters({
      authenticated: 'auth/check',
      user: 'auth/user',
    }),
    ...mapGetters('wizard', ['isArFullscreenActive'])
  }
}
</script>
